import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import css from './SectionHeader.css'

const CONTAINER_CLASSES = {
  page: css.pageContainer,
}

const CONTENT_CLASSES = {
  page: css.pageContent,
  article: css.articleContent,
  minorArticle: css.minorArticleContent,
}
const CONTENT_MAX_CLASSES = {
  '': css.pageContentMax,
  LG: css.pageContentMaxLG,
}
const CONTENT_ALIGN_CLASSES = {
  left: css.leftAlign,
  center: css.centerAlign,
  right: css.rightAlign,
}

const TITLE_CLASSES = {
  page: css.pageTitle,
  article: css.articleTitle,
  minorArticle: css.minorArticleTitle,
}

export const SectionHeader = ({ title, children, type, contentAlign, contentSizeMax }) => (
  <header className={CONTAINER_CLASSES[type]}>
    <div
      className={classnames(
        CONTENT_CLASSES[type],
        type === 'page' ? CONTENT_MAX_CLASSES[contentSizeMax] : '',
        CONTENT_ALIGN_CLASSES[contentAlign],
      )}
    >
      <h1 className={TITLE_CLASSES[type]}>{title}</h1>
      {children}
    </div>
  </header>
)

SectionHeader.propTypes = {
  children: PropTypes.node,
  contentAlign: PropTypes.oneOf(['', 'left', 'center', 'right']),
  contentSizeMax: PropTypes.oneOf(['', 'LG']),
  type: PropTypes.oneOf(['', 'page', 'article', 'minorArticle']),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

SectionHeader.defaultProps = {
  children: null,
  contentAlign: '',
  contentSizeMax: '',
  type: 'page',
}
